// removed by extract-text-webpack-plugin
module.exports = {"NavigationItem":"navigationItem__NavigationItem__3Z-1G","active":"navigationItem__active__35iuh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItem/navigationItem.css
// module id = 118
// module chunks = 8